import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DisabledOutlineSwitchs } from "../../../../Constant";
import { DISABLED_OUTLINE_SWITCH, DISABLED_OUTLINE_SWITCH_LIST } from "../../../../Data/FormWidgets";
import CommonSwitchSpan from "../Common/CommonSwitchSpan";

const DisabledOutlineSwitch = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={DisabledOutlineSwitchs} span={DISABLED_OUTLINE_SWITCH} />
        <CardBody className="common-flex">
          {DISABLED_OUTLINE_SWITCH_LIST.map((item, index) => (
            <div className="d-flex" key={index}>
              <div className="flex-grow-1 text-end icon-state switch-outline">
                <CommonSwitchSpan key={index} color={item} />
              </div>
            </div>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default DisabledOutlineSwitch;
